export default __webpack_public_path__ + "static/media/garbage-no-frequency.b1151f5a.svg";